// extracted by mini-css-extract-plugin
export default {"title":"SuccessStoriesTitle_title__doAza","subTitle":"SuccessStoriesTitle_subTitle__Dwj3Y"};